import http from '@/utils/http'
import axios from 'axios'

const formatParams = params => Object.keys(params).map(k => [k, params[k]].join('=')).join('&')

const preregister = () => http()
  .post('/preregistered_cards')
  .then(x => x.data)

const tokenize = (cardNumber, cardMonth, cardYear, cardCvx, data) => axios
  .post(data.card_registration_url, formatParams({
    data: data.preregistration_data,
    accessKeyRef: data.access_key,
    cardNumber,
    cardCvx,
    cardExpirationDate: [
      cardMonth,
      cardYear.substr(-2)
    ].join('')
  }), {
    headers: { 'Content-Type': 'text/plain' }
  })
  .then(x => x.data)

const finalize = (preregisteredCard, token) => http()
  .put(`/cards/${preregisteredCard.id}`, {
    registration_data: token
  })
  .then(x => x.data)

const create = (cardNumber, month, year, cvx) => preregister()
  .then(preregisteredCard => tokenize(cardNumber, month, year, cvx, preregisteredCard)
    .then(token => finalize(preregisteredCard, token))
  )
  .then(x => x.status === 'ERROR'
    ? Promise.reject(x)
    : x
  )

export default {
  create
}



// WEBPACK FOOTER //
// ./src/api/card.js